import { LoadingButton } from "@mui/lab";
import { Box, Dialog, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
    open: boolean,
    title: string,
    loading: boolean,
    onCancel: VoidFunction,
    onConfirm: VoidFunction
}


const ConfirmDialog = ({ open, title, loading, onCancel, onConfirm }: Props) => {
    const { t } = useTranslation('global')

    return <Dialog
        open={open}
    >
        <Box sx={{ width: '500px', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box>
                <Typography variant='h6'>{title}</Typography>
                <Box mt={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        variant="contained"
                        onClick={onCancel}
                        sx={{
                            textTransform: 'none',
                            mr: 1,
                            width: 100,
                            height: 40,
                            background: '#f4f6f8',
                            color: '#3a3b3c',
                            '&:hover': {
                                background: 'gray',
                                color: "#f4f6f8"
                            },
                        }}
                    >
                        {t("Cancel")}
                    </Button>
                    <Button variant='contained' color='secondary' disabled={loading} onClick={onConfirm} sx={{ textTransform: 'none', color: '#fff', width: 100, height: 40 }}>
                        {
                            loading ?
                                <LoadingButton loading >
                                    Loading...
                                </LoadingButton>
                                : t("Confirm")
                        }
                    </Button>
                </Box>
            </Box>
        </Box>
    </Dialog>
}
export default ConfirmDialog;